export function getTrackingNumbers(trackingDetails = []) {
  return trackingDetails
    .map((entry) => entry?.tracking_number || entry?.trackingNumber || "")
    .map((trackingNumber) => trackingNumber.trim())
    .filter(Boolean);
}

export function hasReleaseNotesContent(order) {
  return Boolean(order?.finalReleaseNotes?.trim() || getTrackingNumbers(order?.trackingDetails).length);
}

export function getReleaseNotesLines(order) {
  const releaseNotes = order?.finalReleaseNotes?.trim();
  const trackingNumbers = getTrackingNumbers(order?.trackingDetails);
  const lines = [];

  if (releaseNotes) lines.push(releaseNotes);
  if (trackingNumbers.length) lines.push(`Tracking: ${trackingNumbers.join(", ")}`);
  if (lines.length === 0) lines.push("-");

  return lines;
}
